import 'Styles/templates/collection.footwear.scss';

import collectionGridApp from '../vue/collection-grid/index';
import AutoplayVideo from '../components/autoplay-video';

collectionGridApp();
AutoplayVideo();